import { createTheme } from '@mui/material/styles';

export const crvWebTokens = {
  brand: {
    green900: '#0E3F31',
    green800: '#145C46',
    green700: '#1D6B52',
    green600: '#2D7A60',
    green100: '#DDEBE2',
    ink900: '#111B17',
    ink700: '#1D2520',
    slate600: '#526057',
    slate300: '#CBD5CF',
    paper50: '#F7F8F5',
    paper0: '#FFFFFF',
    steel600: '#3B6E8F',
    amber600: '#B7791F',
  },
  shell: {
    railWidth: 276,
    topBarHeight: 64,
  },
} as const;

export const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: crvWebTokens.brand.green800,
      light: crvWebTokens.brand.green600,
      dark: crvWebTokens.brand.green900,
      contrastText: crvWebTokens.brand.paper0,
    },
    secondary: {
      main: crvWebTokens.brand.steel600,
      contrastText: crvWebTokens.brand.paper0,
    },
    warning: {
      main: crvWebTokens.brand.amber600,
    },
    text: {
      primary: crvWebTokens.brand.ink700,
      secondary: crvWebTokens.brand.slate600,
    },
    divider: '#D9DFD6',
    background: {
      default: crvWebTokens.brand.paper50,
      paper: crvWebTokens.brand.paper0,
    },
  },
  shape: {
    borderRadius: 8,
  },
  typography: {
    fontFamily: '"Manrope", "Inter", "Segoe UI", "Helvetica Neue", Arial, sans-serif',
    h4: { fontWeight: 700, letterSpacing: 0 },
    h5: { fontWeight: 700 },
    h6: { fontWeight: 700 },
    button: { fontWeight: 700, textTransform: 'none', letterSpacing: 0 },
  },
  components: {
    MuiAlert: {
      styleOverrides: {
        root: {
          borderRadius: 8,
        },
      },
    },
    MuiButton: {
      defaultProps: {
        disableElevation: true,
      },
      styleOverrides: {
        root: {
          borderRadius: 8,
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderColor: '#D9DFD6',
        },
      },
    },
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          minWidth: 0,
        },
        '#root': {
          minHeight: '100vh',
        },
      },
    },
  },
});
